import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "question-answer-image-uploader"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_w_html_tool_tip = _resolveComponent("w-html-tool-tip");
  const _component_image_uploader = _resolveComponent("image-uploader");
  const _component_confirm_dialog = _resolveComponent("confirm-dialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_ctx.image ? (_openBlock(), _createBlock(_component_w_html_tool_tip, {
    key: 0,
    placement: "top",
    "hide-after": 100,
    popperClass: "quiz-answer-image-preview-popper"
  }, {
    content: _withCtx(() => [_createElementVNode("img", {
      src: _ctx.getImagePath(_ctx.image),
      class: "answer-image-preview"
    }, null, 8, _hoisted_2)]),
    default: _withCtx(() => [_createElementVNode("div", {
      class: "image-container",
      onClick: _cache[0] || (_cache[0] = $event => _ctx.onImageDeleteClick())
    }, [_createElementVNode("img", {
      src: _ctx.getImagePath(_ctx.image, true),
      class: "item-image"
    }, null, 8, _hoisted_3), _createVNode(_component_icon, {
      icon: "delete-outline",
      class: "image-delete-icon",
      size: "small"
    })])]),
    _: 1
  })) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "image-upload-icon-container",
    onClick: _cache[1] || (_cache[1] = $event => _ctx.displayImageUploader = true)
  }, [_createVNode(_component_icon, {
    icon: "image-outline",
    class: "image-upload-icon"
  })])), _ctx.displayImageUploader ? (_openBlock(), _createBlock(_component_image_uploader, {
    key: 2,
    visible: _ctx.displayImageUploader,
    orientation: "square",
    "upload-api-url": _ctx.uploadApiUrl,
    onUploadResult: _ctx.onImageUploaded,
    onClose: _cache[2] || (_cache[2] = $event => _ctx.displayImageUploader = false)
  }, null, 8, ["visible", "upload-api-url", "onUploadResult"])) : _createCommentVNode("", true)]), _createVNode(_component_confirm_dialog, {
    "v-if": _ctx.image && _ctx.displayItemImageDeletionDialog,
    visible: _ctx.displayItemImageDeletionDialog,
    title: _ctx.$t('chapter.question.answerImage.deleteDialog.title'),
    message: _ctx.$t('chapter.question.answerImage.deleteDialog.message'),
    dialogClass: "answer-image-delete-dialog",
    "confirm-button-text": _ctx.$t('messageBox.delete'),
    "cancel-button-text": _ctx.$t('messageBox.cancel'),
    "close-on-outside-click": false,
    onOnConfirmed: _cache[3] || (_cache[3] = $event => _ctx.onItemImageDeleteConfirm()),
    onOnDialogClose: _cache[4] || (_cache[4] = $event => _ctx.onItemImageDeleteCancel()),
    onOnCanceled: _cache[5] || (_cache[5] = $event => _ctx.onItemImageDeleteCancel())
  }, null, 8, ["v-if", "visible", "title", "message", "confirm-button-text", "cancel-button-text"])], 64);
}